import React, { useEffect } from 'react';

import { showToast } from '@opendoor/bricks/complex/Toast';
import { Box, Button, Flex, Heading } from '@opendoor/bricks/core';

import { PropertyCard } from 'buying/components/propertyCards/PropertyCard';
import {
  ShowingRequestPropertyQuery_buyer_getPropertyByAddressId_property as ShowingRequestProperty,
  ShowingRequestPropertyQuery_buyer_getPropertyByAddressId_property_visitationOptions as VisitationOption,
} from 'buying/graphql/queries/__generated__/ShowingRequestPropertyQuery';
import { PropertyCardProperty as Property } from 'buying/graphql/useProperties';

type ConfirmationProperty = Pick<
  ShowingRequestProperty,
  'opendoorOwned' | 'instantTours' | 'visitationOptions'
> &
  Property;
interface IPropertyConfirmationProps {
  property?: ConfirmationProperty | null;
  handleOnNext: () => void;
  opendoorOwned?: boolean;
  isHomebuilder?: boolean;
}

const isPropertyUnlockable = (property: ConfirmationProperty) => {
  return (
    !!property?.opendoorOwned &&
    (!!property?.instantTours ||
      !!property?.visitationOptions?.some(
        (item: VisitationOption) => item.option === 'all_day_open_house',
      ))
  );
};
/**
 * Property confirmation step
 *
 * storybook-check-ignore
 */
export const PropertyConfirmation: React.FC<IPropertyConfirmationProps> = ({
  property,
  handleOnNext,
}) => {
  const cannotServiceTour = property && !isPropertyUnlockable(property);
  const buttonText = cannotServiceTour ? 'Done' : 'Continue';

  useEffect(() => {
    if (cannotServiceTour) {
      showToast(
        'info',
        'This property is not currently available to tour.',
        'cake-tour-creation-flow-tour-unavailable',
        {
          toastOptions: { position: 'top-center' },
        },
      );
    }
  }, [cannotServiceTour]);

  return (
    <Flex alignItems="center" flexDirection="column" mt={10} gridGap="3">
      <Box mb={5}>
        <Heading size="UNSAFE_h2" as="h2" mb={3}>
          Tour {property?.street}
        </Heading>
      </Box>
      <Flex flexDirection="column" width={['100%', null, '350px']} gridGap="3">
        {property && <PropertyCard showFavoriteButton={false} property={property} width="100%" />}
        <Button
          type="button"
          variant="primary"
          analyticsName="cake-tour-creation-flow-property-confirmation-next"
          aria-label={buttonText}
          onClick={handleOnNext}
          mt={5}
        >
          {buttonText}
        </Button>
      </Flex>
    </Flex>
  );
};
